import getConfig from 'next/config';

import fhhData from 'shared/seo/data/fhh.json';
import { fhhCities, fhhCountries, fhhMapping } from '../../../data';
import { verticals } from '../../../data/verticals';

import type { Destination } from '../../../interfaces/destination';
import { PopularCities } from 'shared/seo/PopularCities';
import { LinkTree } from 'shared/seo/LinkTree';
import { DestinationPage } from '../../../components/DestinationPage';
import { Offers } from '../../../components/offers/Offers';

const {
    serverRuntimeConfig: { fhhOfferUrl },
} = getConfig();

const baseApiUrl = `${fhhOfferUrl}?no_of_beds_from=2&mobile=false&nrFUSAds=0`;

export async function getStaticPaths() {
    const destinations = fhhCities.map((dest: Destination) => ({
        params: { cityLevel1: dest.level1.cityPath, countryLevel1: dest.level1.countryPath },
    }));
    return {
        paths: destinations,
        fallback: false,
    };
}

export async function getStaticProps(context) {
    const destination = fhhCities.find(
        (entry: Destination) =>
            entry.level1.cityPath === context.params.cityLevel1.toLowerCase() &&
            entry.level1.countryPath === context.params.countryLevel1.toLowerCase(),
    );
    const destinationCountry = fhhCountries.find(
        (entry: Destination) => entry.level1.countryPath === context.params.countryLevel1.toLowerCase(),
    );

    const popularCities = fhhMapping[destination.id] ?? fhhMapping[destinationCountry.id] ?? [];

    const searchType = destination.level1.country.toLowerCase() === 'norge' ? 'municipality' : 'locality';
    const offers = await fetch(encodeURI(`${baseApiUrl}&country=${destination.level1.country}&${searchType}=${destination.level1.city}`))
        .then((res) => (res.ok ? res.json() : Promise.reject(`Fetching offers failed (${res.status}): ${res.url}`)))
        .then((json) => json.resultItems ?? [])
        .catch((err) => {
            console.warn(err);
            return [];
        });
    return { props: { destination, popularCities, offers } };
}

const CityLevel1 = ({ destination, popularCities, offers }) => (
    <DestinationPage pageType="cityLevel1" destination={destination} vertical={verticals.fhh} data={fhhData}>
        <Offers
            destination={destination.level1.city}
            offers={offers}
            vertical={verticals.fhh}
            heading={fhhData.lang.headingOffers}
            showMap
        />
        <PopularCities
            destination={destination}
            cities={popularCities}
            cdnUrl={fhhData.cdnPath}
            verticalUrl={fhhData.basePath}
            lang={fhhData.lang}
        />
        <LinkTree
            heading={fhhData.lang.linkTree.heading}
            description={fhhData.lang.linkTree.description}
            data={fhhData.linkTree}
            url={fhhData.basePath}
        />
    </DestinationPage>
);

export default CityLevel1;
